import React from "react";
import { Navigate, Outlet, useRoutes } from "react-router-dom";
import appRoutes from "app/config/routes";
import { SchoolProfilePage, SchoolsPage } from "app/modules/schools/pages";
import { AuthPage } from "../../modules/auth/pages";
import PrivateRoute from "../PrivateRoute";
import { StaffManagementPage, StaffProfilePage } from "app/modules/hr/pages";
import CreatePayroll from "app/modules/hr/components/CreatePayroll";
import DashboardIndex, {
  CoachingDashboardPage,
  CollegeDashboardPage,
  GroupOfInstitutesDashboardPage,
  SchoolDashboardPage,
} from "app/modules/dashboard/pages";
import Layout from "app/layout";
import SchoolManagementIndex, {
  SessionSettingsPage,
  DepartmentsPage,
  ClassesPage,
  AccessControlPage,
  InvitationCodePage,
} from "app/modules/school-management/pages";
import {
  VisitorControlPage,
  ComplainsPage,
  StaffAttendancePage,
} from "app/modules/reception/pages";
import {
  StudentManagementPage,
  CreateStudentPage,
  StudentProfilePage,
  StudentIdCardPage,
  ExistStudentPage,
  MigrationPage,
  EditMigrationPage,
  StudentReportPage,
} from "app/modules/student/pages";
import {
  AdmitCardPage,
  PrintAdmitCardPage,
  ReportCardPage,
  TestExamsPage,
} from "app/modules/exam-control/pages";
import ValidateSession from "app/modules/auth/pages/ValidateSession";
import {
  AttendanceAndLeavePage,
  HomeWorkPage,
  TimeTablePage,
  SyllabusPage,
  SubjectDetailsPage,
  AcademicCalendarPage,
} from "app/modules/academics/pages";
import FeeCollectioPage from "app/modules/fee-management/fee-collection";

// Import modules
import PromotionAndMigration from "app/modules/student/pages/PromotionAndMigration";
import PromoteModal from "app/modules/student/pages/PromotionAndMigration/PromoteModal";
import {
  CollectionPage,
  ExpensesPage,
  FirmInvoicePage,
  LedgerReportPage,
} from "app/modules/LedgerAccount";
import { FeeStructurePage, RouteDetailPage } from "app/modules/transport/pages";
import FeeStructure from "app/modules/fee-management/fee-structure";
import {
  NoticeBoardPage,
  TextSMSPage,
  WhatsAppPage,
} from "app/modules/communication/index";
import AddNewStaffPage from "app/modules/hr/pages/addNewStaff";
import { TransportDetailPage } from "app/modules/transport/pages";
import JoiningApproval from "app/modules/hr/components/JoiningApproval";
import { AboutSchoolPage } from "app/modules/schools/pages";
import AdmissionApproval from "../../modules/student/pages/AdmissionApproval";
import { StaffLeavePage } from "app/modules/hr/pages";
import EditDetails from "app/modules/student/components/AdmissionApproval/EditDetails";
import InvoiceComponent from "app/components/Invoice/InvoiceComponent";
import { UserProfilePage } from "app/modules/userProfile/pages";
import UserHeader from "app/layout/Header/UserHeader";
import ApplySchool from "app/modules/schools/pages/Schools/ApplySchool";
import {
  DeviceDetailPage,
  PunchLogPage,
  UserDetailPage,
} from "app/modules/bio-metric/pages";
import ForgotPassword from "app/modules/auth/components/ForgotPassword";
import FirmsPage from "app/modules/LedgerAccount/pages/firms/Firms";
import FirmProfile from "app/modules/LedgerAccount/pages/firms/FirmProfile";
import BooksPage from "app/modules/LedgerAccount/pages/books/BooksPage";
import PaySlip from "app/modules/LedgerAccount/pages/PaySlip";
import PrintSlip from "app/modules/hr/components/PrintSlip";
import SubHeadsPage from "app/modules/LedgerAccount/pages/SubHeadsPage";
import ExpenseSubHeadsPage from "app/modules/LedgerAccount/pages/ExpenseSubHeads";
import InvoiceComponent2 from "../Invoice/InvoiceComponent2";
import StaffPayroll from "app/modules/hr/pages/StaffPayroll";
import {
  ArrearPage,
  CollectFeePage,
  FeeCollection2Page,
  FeeDiscountPage,
  FeesInvoicePage,
  FeesReportPage,
} from "app/modules/fee-management";
import SessionOrderInvoice from "../Invoice/SessionOrderInvoice";
import ArrearInvoice from "../Invoice/ArrearInvoice";
import AdmissionEnquiry from "app/modules/reception/pages/AdmissionEnquiry";
import Certificate from "app/modules/student/pages/Certificate";
import {
  AchievementsPage,
  AlumniAchieverPage,
  ChiefGuestPage,
  ClassPhotoPage,
  FounderPage,
  SchoolGalleryPage,
  SchoolTeamPage,
  SchoolTopperPage,
  SportAchieverPage,
  ThoughtOfTheDayPage,
  WebsitePopupPage,
  WebsiteSliderPage,
} from "app/modules/website-builder";
import YouTubeVideo from "app/modules/website-builder/YouTubeVideo";
import NewsCalendar from "app/modules/website-builder/NewsCalendar";
import AlumniIndex from "app/modules/student/pages/Alumni";
import BulkUpdate from "app/modules/student/pages/StudentManagment/BulkUpdate";
import {
  CounselorPage,
  EnquiryPage,
  FormFeeStructurePage,
  PreviousSchoolPage,
  VisualsPage,
} from "app/modules/admissionEnquiry";
import { PermissionPage } from "app/modules/counselorPermission";

const routes = [
  {
    path: "/",
    element: (
      <Layout>
        <Outlet />
      </Layout>
    ),
    children: [
      // login page
      {
        path: `/`,
        element: <Navigate to={`/${appRoutes.login}`} />,
      },

      //admission-enquiry
      {
        path: `/${appRoutes.admissionEnquiry}`,
        element: <Outlet />,
        children: [
          {
            path: `/${appRoutes.visuals}`,
            element: (
              <PrivateRoute>
                <VisualsPage />
              </PrivateRoute>
            ),
          },
          {
            path: `/${appRoutes.enquiry}`,
            element: (
              <PrivateRoute>
                <EnquiryPage />
              </PrivateRoute>
            ),
          },
          {
            path: `/${appRoutes.counselor}`,
            element: (
              <PrivateRoute>
                <CounselorPage />
              </PrivateRoute>
            ),
          },
          {
            path: `/${appRoutes.formFeeStructure}`,
            element: (
              <PrivateRoute>
                <FormFeeStructurePage />
              </PrivateRoute>
            ),
          },
          {
            path: `/${appRoutes.previousSchool}`,
            element: (
              <PrivateRoute>
                <PreviousSchoolPage />
              </PrivateRoute>
            ),
          },
        ],
      },
      //persmission
      {
        path: `/${appRoutes.permissions}`,
        element: <Outlet />,
        children: [
          {
            path: `/${appRoutes.permissions}`,
            element: (
              <PrivateRoute>
                <PermissionPage />
              </PrivateRoute>
            ),
          },
        ],
      },
      {
        path: `*`,
        element: <>Not Found</>,
      },
    ],
  },

  {
    path: `/${appRoutes.schools}`,
    element: (
      <PrivateRoute>
        <UserHeader />
        <SchoolsPage />
      </PrivateRoute>
    ),
  },
  {
    path: `/${appRoutes.applySchool}`,
    element: (
      <PrivateRoute>
        <UserHeader />
        <ApplySchool />
      </PrivateRoute>
    ),
  },
  {
    path: `/${appRoutes.userProfile}`,
    element: (
      <PrivateRoute>
        <UserHeader />
        <UserProfilePage />
      </PrivateRoute>
    ),
  },
  {
    path: `/${appRoutes.login}`,
    element: <AuthPage />,
  },
  {
    path: `/${appRoutes.register}`,
    element: <AuthPage />,
  },
  {
    path: `/${appRoutes.forgotPassword}`,
    element: <ForgotPassword />,
  },
  // {
  //   path: `/${appRoutes.passwordChange}`,
  //   element: <PasswordChange />
  // },
  // {
  //   path: `/password-change`,
  //   element: <Navigate to={`/${appRoutes.passwordChange}`} />,
  // },
  {
    path: `/${appRoutes.validateSession}`,
    element: <ValidateSession />,
  },
];

const AppRoutes = () => {
  const appRoutes = useRoutes(routes);
  return appRoutes;
};

export default AppRoutes;
